// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from 'react'
import compose from 'recompose/compose'
import { connect } from 'react-redux'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import Cross from '../svg/cross'
import Homepage from '../svg/homepage'

import OneManySymbol from '../symbols/one-many'

import Link from '../link'
import '../link/style.less'

import Glider from './glider'
import './glider/style.less'

import { updateHeaderState } from '../../state/actions'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
const { Fragment } = React

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
const MobileHeader = React.memo(({ headerState, updateHeaderState }) => (
  <Fragment>
    &nbsp;
    <Glider>
      <Row>
        <Col xs={20} sm={20} md={20} lg={0} xl={0} xxl={0}>
          <nav>
            <li>Nav 1...</li>
            <li>Nav 2...</li>
            <li>Nav 3...</li>
          </nav>
        </Col>
        <Col xs={4} sm={4} md={4} lg={0} xl={0} xxl={0}>
          <Link
            to="#"
            className="action"
            onClick={(e) => {
              e.preventDefault()
              updateHeaderState({
                isActive: !headerState.isActive,
                whatsActive:
                  headerState.isActive === false ? 'mobile-menu' : 'root',
              })
            }}
          >
            <Cross />
            <span>Close</span>
          </Link>
          <br />
          <Link to="/" className="action">
            <Homepage />
            <span>Home</span>
          </Link>
        </Col>
      </Row>
    </Glider>
  </Fragment>
))

// ----------------------------------------------------------------------------
// ---------------------------------------------------------------------- State
// ----------------------------------------------------------------------------
const withState = connect(
  (state) => ({
    headerState: state.headerState,
  }),
  (dispatch) => ({
    updateHeaderState(payload) {
      dispatch(updateHeaderState(payload))
    },
  })
)

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Compose
// ----------------------------------------------------------------------------
/** Compose ala FP style */
const ComposedMobileHeader = compose(
  withState // Add state
)(MobileHeader)

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default ComposedMobileHeader
